import vanOnePic from "./index.vue";

/* istanbul ignore next */
vanOnePic.install = function(Vue) {
  Vue.component(vanOnePic.name, vanOnePic);
};

export default vanOnePic;
